import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    ConsolidatedShippingRate,
    ShippingAddress,
    ShippingDetails,
    ShippingServiceIds
} from 'src/app/shared-core/models/cart-data.model';

@Component({
    selector: 'app-shipping-selector',
    templateUrl: './shipping-selector.component.html',
    styleUrls: ['./shipping-selector.component.scss']
})
export class ShippingSelectorComponent {
    @Input() public pageScope: string;
    @Input() public ratesForm: FormGroup;
    @Input() public postalCodeForm: FormGroup;
    @Input() public shippingDetails: ShippingDetails = null;
    @Output() public getNewShippingQuote = new EventEmitter();

    // This only exists due to a bug in <mdb-checkbox>
    // see https://mdbootstrap.com/support/angular/mdb-checkbox-displaying-but-not-working-on-click/
    public requestInsuranceId = 'requestInsurance';    
    public get showPostalCodeForm(): boolean {
        return this.pageScope === 'cart' && Boolean(this.postalCodeForm);
    }

    public get shippingAddress(): ShippingAddress {
        return this.shippingDetails?.ShippingQuote?.ShippingAddress;
    };

    public get consolidatedShippingRates(): ConsolidatedShippingRate[] {
        return this.shippingDetails?.ShippingQuote?.ConsolidatedShippingRates;
    }

    public get unableToImmediatelyShipItems(): string[] {
        return this.shippingDetails?.ShippingQuote?.FulfillmentStrategy?.UnableToImmediatelyShipItems ?? [];
    }

    public get postCode(): string {
        if (!this.shippingAddress || !this.shippingAddress.PostalCode) {
            return  '';
        }

        // Canada Post Code is like "M5A 4S9"
        // USA Post Code is like 90210
        const postCode = this.shippingAddress.PostalCode;
        if (isNaN(this.shippingAddress.PostalCode as any)) {
            return  `${postCode.substring(0, 3)} ${postCode.substring(3)}`;
        }

        return postCode;
    }

    public get isCartPage(): boolean {
        return this.pageScope === 'cart';
    }

    public get isEligibleForInsurance(): boolean {
        return this.shippingDetails?.ShippingQuote?.IsEligibleForInsurance ?? false;
    }

    public get insuranceCost(): number {
        return this.shippingDetails?.CustomerInsuranceCost ?? 0;
    }

    public getFriendlyName(rate: ConsolidatedShippingRate) {
        const hiddenCompanyServices = [
            ShippingServiceIds.ProfusionShippingService.toString(),
            ShippingServiceIds.FreeShippingService.toString()
        ];
        
        if (hiddenCompanyServices.includes(rate.ShippingServiceId)) {
            // for profusion or free shipping, we don't return the company name since it's handled by us.
            return rate.ShippingService;
        }

        return `${rate.ShippingCompany} ${rate.ShippingService}`;
    }
}